import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Input,
  Row,
  Col,
  Collapse,
} from "reactstrap";
import { useHistory } from "react-router-dom";
import { search } from "redux/actions/Screening/screeningActions";
import { connect } from "react-redux";

const Pesquisar = (props) => {
  // ** Const
  const history = useHistory();
  const { open, setOpen } = props;
  const [search, setSearch] = useState("");
  const [openMenu, setOpenMenu] = useState(true);
  const [openCard, setOpenCard] = useState(true);
  const [openAba, setOpenAba] = useState(true);

  useEffect(() => {
    setSearch(props.searchInput);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.searchInput]);

  useEffect(() => {
    let searchReplace = search.replace(/"/g, "'");
    props.search({
      params: { arg2: localStorage.getItem("area"), arg1: searchReplace },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search]);

  return (
    <Modal
      isOpen={open}
      toggle={() => setOpen(!open)}
      className={`modal-dialog-centered`}
      size="xl"
    >
      <ModalHeader toggle={() => setOpen(!open)}>
        <span style={{ fontSize: 15 }}>
          Buscar por Menu-Card-Aba (Área:{localStorage.getItem("area")})
        </span>
      </ModalHeader>
      <ModalBody>
        <Input value={search} onChange={(e) => setSearch(e.target.value)} />
        <div style={{ marginTop: 15, marginBottom: 10 }}>
          <div
            onClick={() => setOpenMenu(!openMenu)}
            style={{ fontWeight: 900, fontSize: 17, marginBottom: 10 }}
          >
            <span style={{ textDecoration: "underline" }}>Menus</span>{" "}
            <i
              style={{
                position: "absolute",
                paddingTop: "5px",
                paddingLeft: "6px",
                cursor: "pointer",
              }}
              className={
                openMenu ? "nc-icon nc-minimal-down" : "nc-icon nc-minimal-up"
              }
            />
          </div>
          <Collapse isOpen={openMenu}>
            <Row>
              {props.searchList?.menus?.map((item, index) => (
                <Col xs={12} md={4} style={{ marginBottom: 15 }}>
                  <span
                    style={{
                      cursor: "pointer",
                      textDecoration: "underline",
                      color: "#34B5B8",
                      fontWeight: 600,
                    }}
                    onClick={() => {
                      history.push(`/admin/${item.area}/menu/${item.id}`);
                      setOpen(!open);
                    }}
                  >
                    {item.menu}
                  </span>
                </Col>
              ))}
            </Row>
          </Collapse>
          <div
            onClick={() => setOpenCard(!openCard)}
            style={{ fontWeight: 900, fontSize: 17, marginBottom: 10 }}
          >
            <span style={{ textDecoration: "underline" }}>Cards</span>{" "}
            <i
              style={{
                position: "absolute",
                paddingTop: "5px",
                paddingLeft: "6px",
                cursor: "pointer",
              }}
              className={
                openCard ? "nc-icon nc-minimal-down" : "nc-icon nc-minimal-up"
              }
            />
          </div>
          <Collapse isOpen={openCard}>
            <Row>
              {props.searchList?.cards?.map((item, index) => (
                <Col xs={12} md={6} lg={4} style={{ marginBottom: 15 }}>
                  <div style={{ fontSize: 10, color: "gray" }}>
                    Menu {">"} {item.menu}
                  </div>
                  <span
                    style={{
                      cursor: "pointer",
                      textDecoration: "underline",
                      color: "#34B5B8",
                      fontWeight: 600,
                    }}
                    onClick={() => {
                      history.push(`/admin/${item.area}/menu/${item.id}`);
                      setOpen(!open);
                    }}
                  >
                    {item.titulo}
                  </span>
                </Col>
              ))}
            </Row>
          </Collapse>

          <div
            onClick={() => setOpenAba(!openAba)}
            style={{ fontWeight: 900, fontSize: 17, marginBottom: 10 }}
          >
            <span style={{ textDecoration: "underline" }}>Abas</span>{" "}
            <i
              style={{
                position: "absolute",
                paddingTop: "5px",
                paddingLeft: "6px",
                cursor: "pointer",
              }}
              className={
                openAba ? "nc-icon nc-minimal-down" : "nc-icon nc-minimal-up"
              }
            />
          </div>
          <Collapse isOpen={openAba}>
            <Row>
              {props.searchList?.abas?.map((item, index) => (
                <Col xs={12} md={6} lg={4} style={{ marginBottom: 15 }}>
                  <div style={{ fontSize: 10, color: "gray" }}>
                    Menu {">"} {item.menu} 
                  </div>
                  <div style={{ fontSize: 10, color: "gray" }}>
                  Card {'>'} {item.cardTitulo}
                  </div>
                  <span
                    style={{
                      cursor: "pointer",
                      textDecoration: "underline",
                      color: "#34B5B8",
                      fontWeight: 600,
                    }}
                    onClick={() => {
                      history.push(`/admin/${item.area}/menu/${item.id}`);
                      setOpen(!open);
                    }}
                  >
                    {item.titulo}
                  </span>
                </Col>
              ))}
            </Row>
          </Collapse>
        </div>
      </ModalBody>
    </Modal>
  );
};

const mapStateToProps = (state) => {
  return {
    searchList: state.screening.screening.searchList,
  };
};

export default connect(mapStateToProps, { search })(Pesquisar);
